import React from 'react'
import CustomPath from './CustomPath'

const OUTLINE_PATH = 'M33.5929 35.6171L0 35.6171L0 8.54405L33.5929 8.54405L33.5929 0L56 22.0806L33.5929 44V35.6171Z'
const RAW_WIDTH = 56
const RAW_HEIGHT = 44

/**
 * Arrow Right shape component
 * @type {import('./CustomPath').CustomPath}
 */
export const ArrowRightShape = React.forwardRef((props, ref) => {
    return <CustomPath {...props} ref={ref} data={OUTLINE_PATH} rawWidth={RAW_WIDTH} rawHeight={RAW_HEIGHT} />
})

export default ArrowRightShape
